import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    
    constructor(private _authService: AuthService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Skip if the request is not to our API
        if (!request.url.startsWith(environment.apiUrl)) {
            return next.handle(request);
        }

        const generation = this._authService.sessionGeneration;

        // Clone the request and set the authentication token
        let authRequest = request.clone();
        if (this._authService.accessToken) {
            authRequest = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this._authService.accessToken}`
                }
            });
        }

        // Add profile ID if it exists
        if (this._authService.activeProfileId) {
            authRequest = authRequest.clone({
                setHeaders: {
                    'X-Profile-ID': this._authService.activeProfileId
                }
            });
        }

        // Handle the request
        return next.handle(authRequest).pipe(
            catchError((error: HttpErrorResponse) => {
                // Handle 401 Unauthorized errors
                if (error.status === 401) {
                    // Check if this is a login request (we don't want to reload the app for failed login attempts)
                    const isLoginRequest = request.url.includes('/auth/login');
                    
                    // Un 401 de una generación anterior no cierra la sesión vigente.
                    if (!isLoginRequest && generation === this._authService.sessionGeneration) {
                        // Attempt to refresh token or redirect to login
                        this._authService.signOut();
                    }
                }
                
                return throwError(() => error);
            })
        );
    }
} 